export default {
  'coupon-expired': () => import('@icons/coupon/coupon-expired.svg'),
  'coupon-issued': () => import('@icons/coupon/coupon-issued.svg'),
  'coupon-used': () => import('@icons/coupon/coupon-used.svg'),
  'ticket': () => import('@icons/coupon/ticket.svg'),
};
